const Profile = () => {
  return (
    <div className="profileContainer">
      <div className="profileHeader" />
      <div className="profile">
        <div className="profilePicture" />
        <div className="profileTitle">Kartik Dhawan</div>
      </div>
    </div>
  );
};

export default Profile;
